import { configureStore } from '@reduxjs/toolkit';
import { mgmtApi } from './mgmtApi';

const store = configureStore({
  reducer: {
    [mgmtApi.reducerPath]: mgmtApi.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(mgmtApi.middleware),
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
